import { AppProviderContext, appProviderContextTypes } from '../components/AppProvider';
import { Component, createElement } from 'react';
import { Core } from '../Core';
import { hoistNonReactStatics } from '../utils/hoistNonReactStatics';

type AppInjectorProps = { app: Core };

export const InjectApp = <T, P>() => (Target: T) => {
  class AppInjector extends Component<P & AppInjectorProps, {}> {
    static contextTypes = appProviderContextTypes;

    context: AppProviderContext;

    render(): JSX.Element {
      if (this.props.app) {
        console.warn(`You are overriding an injected props !`);
      }
      // tslint:disable-next-line:no-any
      return createElement(Target as any, { app: this.context.appInstance, ...(this.props as any) });
    }
  }

  return hoistNonReactStatics<T, typeof AppInjector, T>(AppInjector, Target);
};



// WEBPACK FOOTER //
// src/app/src/core/hocs/InjectApp.ts